/**
 * Valores por defecto y factories de entradas para la sección PEP. Espejo de
 * @idc-forms/schemas PepDeclaration. Se usan para inicializar el form y para
 * agregar registros vacíos en los field arrays (persona/familiar/socio).
 */

export interface PersonPepEntry {
  id?: string
  institutionWork: string
  position: string
  country: string
  originWealth: string[]
  otherOriginWealth?: string
}

export interface RelativePepEntry {
  id?: string
  institutionWork: string
  position: string
  country: string
  relationship: string
  otherRelationship?: string
  name: { first: string; second?: string; others?: string }
  lastName: { first: string; second?: string; married?: string }
  gender: string
  migrationStatus: string
}

export interface PartnerPepEntry {
  id?: string
  institutionWork: string
  position: string
  country: string
  association: string
  otherAssociation?: string
  name: { first: string; second?: string; others?: string }
  lastName: { first: string; second?: string; married?: string }
  gender: string
  migrationStatus: string
}

export interface PepFormValues {
  isPep: boolean
  pep: PersonPepEntry[]
  hasRelativesPep: boolean
  relativesPep: RelativePepEntry[]
  hasPartnersPep: boolean
  partnersPep: PartnerPepEntry[]
  isCPE: boolean
}

export const PEP_FORM_DEFAULTS: PepFormValues = {
  isPep: false,
  pep: [],
  hasRelativesPep: false,
  relativesPep: [],
  hasPartnersPep: false,
  partnersPep: [],
  isCPE: false
}

export function emptyPersonPep(): PersonPepEntry {
  return { institutionWork: '', position: '', country: '', originWealth: [], otherOriginWealth: '' }
}

export function emptyRelativePep(): RelativePepEntry {
  return {
    institutionWork: '',
    position: '',
    country: '',
    relationship: '',
    otherRelationship: '',
    name: { first: '', second: '', others: '' },
    lastName: { first: '', second: '', married: '' },
    gender: '',
    migrationStatus: ''
  }
}

export function emptyPartnerPep(): PartnerPepEntry {
  return {
    institutionWork: '',
    position: '',
    country: '',
    association: '',
    otherAssociation: '',
    name: { first: '', second: '', others: '' },
    lastName: { first: '', second: '', married: '' },
    gender: '',
    migrationStatus: ''
  }
}

/** Mezcla el sandbox PEP guardado (parcial) sobre los defaults para resetear el form. */
export function toPepFormValues(saved: Record<string, unknown> | null | undefined): PepFormValues {
  if (!saved) return PEP_FORM_DEFAULTS
  return { ...PEP_FORM_DEFAULTS, ...(saved as Partial<PepFormValues>) }
}

/**
 * Normaliza para el ENVÍO: si una bandera quedó en "No", su array NO se manda
 * (respuesta final = No → esos datos no pasan), aunque el cliente los haya cargado
 * y luego cambiado de opinión. En la UI los datos se mantienen (no se borran al
 * togglear); esta limpieza ocurre sólo al enviar.
 */
export function normalizePepForSubmit(values: PepFormValues): PepFormValues {
  return {
    ...values,
    pep: values.isPep ? values.pep : [],
    relativesPep: values.hasRelativesPep ? values.relativesPep : [],
    partnersPep: values.hasPartnersPep ? values.partnersPep : []
  }
}
